module.exports = __webpack_public_path__ + "static/media/covid_qr_p1_2.81bd282e.png";